class GameClient {
    constructor(baseUrl, timeout) {
        this.__baseUrl = baseUrl;
        this.__timeout = timeout;
    }

    getStartedGames() {
        return fetch(this.__baseUrl + "/game/started.secured", {
            signal: AbortSignal.timeout(this.__timeout)
        })
    }

    getNewGames() {
        return fetch(this.__baseUrl + "/game/new.secured", {
            signal: AbortSignal.timeout(this.__timeout)
        })
    }

    getServers() {
        return fetch(this.__baseUrl + "/game/server.admin", {
            signal: AbortSignal.timeout(this.__timeout)
        })
    }
}

const gameClient = new GameClient("./api", 8000);

export default gameClient;